"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giovanni-lupatoto": {
    "aafd1ae7": [{
      "hkey": "d78d2628",
      "slug": "pozzo-camacici",
      "name": "Pozzo-Camacici",
      "primary": true,
      "skipSearch": false
    }],
    "camacici": [{
      "hkey": "d78d2628",
      "slug": "pozzo-camacici",
      "name": "Pozzo-Camacici",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giovanni-lupatoto"
    }],
    "2bf3bc19": [{
      "hkey": "d78d2628",
      "slug": "pozzo-camacici",
      "name": "Pozzo-Camacici",
      "primary": true,
      "skipSearch": false
    }],
    "pozzo": [{
      "hkey": "d78d2628",
      "slug": "pozzo-camacici",
      "name": "Pozzo-Camacici",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;